import NewsFeedPage from "./news-feed.page"
export default NewsFeedPage;
